import React from 'react';
import { TabsTimelineSub } from 'components';
import { tabsBusinessPlan } from './tabsBusinessPlan';
import  SubTabPlan1  from './components/subTabPlan1/index';
import { useSelector } from 'react-redux';

const BusinessPlan = () => {
  const currentSubTab = useSelector(state => state.forms.carrier.currentSubTab) || 0;
  const parseFlag = useSelector(state => state.forms.carrier.parseFlag);
  // const parseFlag = false;

  return (
    <TabsTimelineSub
      tabs={tabsBusinessPlan(parseFlag)}
      currentSubTab={currentSubTab} 
      customClass={'custom-tabs-timeline-sub'}
    />
    // <SubTabPlan1></SubTabPlan1>
  );
};

export default BusinessPlan;